/**
 * French
 *
 */

const locale = {
	"Permission Management": "Gestion des permissions",
	header: {
		"Change Language": "Langues",
		sidemenu: {
			"My channel": "Ma Chaîne",
			"Class Schedule": "Horaire de cours",
			"Student": "étudiant",
			"Class": "classe",
			"Private Class": "私课",
			"Teacher": "老师",
			"Classroom": "教室",
			"Announcement": "公告",
			"Statement Detail": "收支明细",
			"Monthly Summary": "月度汇总",
			"School Management": "学校管理",
			"School Administration": "教务权限",
			"School Information": "学校信息",
			"Sales Management": "销售管理",
		}
	},
	schoolInformation: {
		form: {
			"School Name": "学校中文名称",
			"School Logo": "学校logo",
			"School Home Page": "学校官网主页",
			"Time Zone": "时区",
			"Currency": "货币种类",
		}	
	}
}

export default locale



// WEBPACK FOOTER //
// ./src/locale/translations/FR.js